module.exports = __webpack_public_path__ + "static/assets/33c7b3d06039af0e27cefff9221c16da.svg";